module.exports = __webpack_public_path__ + "img/upload_icon.56d5abfc.svg";